function save_user_credentials(user_credentials,_this){
    window.api.send('save_user_credentials_messege',JSON.parse(JSON.stringify(user_credentials))); 
    window.api.receive("save_user_credentials_reply", (credentials_saving_result) => {
            _this.messag = credentials_saving_result;
            _this.isVisible = true;
    }); 
}

function save_generate_credentials(generate_credentials,_this){
    window.api.send('save_generate_credentials_messege', generate_credentials ); 
    window.api.receive("save_generate_credentials_receive", (token_save_result) => {
        if(token_save_result=="Token saved sucessfully"){
            _this.token_button_visible= "Refresh";   
        }
        else{
            _this.token_button_visible= "Generate";
        }
        //   console.log(credentials_receive_result,"neha");
    }); 
}

function getConfigurationCredentials(_this,meta,license_no){
    if(meta != 'vue'){
        window.api.send('fetch_license_messege'); 
        window.api.receive("fetch_license_reply", (user_config_obj,license) => {
           _this.form_data.ip_address = user_config_obj.user_ip;
           _this.form_data.port_no = user_config_obj.user_port;
           _this.form_data.License_no = license;
        });
    }
    else{

    }
}


export {save_user_credentials,getConfigurationCredentials,save_generate_credentials}